import * as React from 'react';
import { Global } from '@emotion/react';
import cssBaselineWebSkinOverrides from 'src/styles/themes/cssBaselineWebSkinOverrides';
import GlobalUnifyTokensStyles from 'src/styles/unify-tokens-adapter/components/GlobalUnifyTokensStyles';
import AdelleSansFontFaceDecl from 'src/styles/fonts/AdelleSansFontFaceDecl';
import MaterialSymbolsFontFaceDecl from 'src/styles/fonts/MaterialSymbolsFontFaceDecl';

/**
 * This is kinda like our CSSBaseline - but without all the MUI component / styleOverrides / ColorSchemeContext nonsense.
 */
//language=CSS
const styles = `
@keyframes mui-auto-fill {
  /* Global styles for InputBase
     Used due to InputBaseProps.disableInjectingGlobalStyles being defaulted 
     to true within muiInputBaseStyleOverrides for UnifyThemeProvider.
     
     @see https://github.com/mui/material-ui/issues/34436#issuecomment-1256208729 */
  from { display: block; }
  to { display: block; }
}

* {
  /* Necessary to override the MUI default / match the styles applied
     when web-skin.css is on the page. */
  box-sizing: border-box;
}

*::before, *::after {
  /* Necessary to override the MUI default / match the styles applied
     when web-skin.css is on the page. */
  box-sizing: initial;
}

html {
  /* On the off chance there is no UnifyThemeProvider on the page... 
     set the MUI default font smoothing.  */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: antialiased;
  /* This is necessary to make 1rem == 10px so that all existing
     hard-coded rem values in consumer stylesheets will have the
     same pixel value when the switch to MUI occurs and the
     web-skin stylesheets are removed. */
  font-size: 62.5%;
}

${cssBaselineWebSkinOverrides}

${AdelleSansFontFaceDecl}
${MaterialSymbolsFontFaceDecl}
`;

/**
 * Rendered by our custom {@link CssBaseline} component.
 *
 * @access package
 */
export const GlobalUnifyStyles: React.FC = function GlobalUnifyStyles() {
  return (
    <>
      <Global styles={styles} />
      <GlobalUnifyTokensStyles />
    </>
  );
};

export default GlobalUnifyStyles;
